import { apiClient } from './api';
import type { CoachNotification, CoachProfile, NextTrainerRunInfo } from './types';

interface NotificationsResponse {
  coach: CoachProfile;
  notifications: CoachNotification[];
}

interface UnreadCountResponse {
  unreadCount: number;
}

interface MarkReadResponse {
  notification: CoachNotification;
  unreadCount: number;
}

interface MarkAllReadResponse {
  status: string;
  updated: number;
  unreadCount: number;
}

export class CoachNotificationService {
  static async getNotifications(agentType?: string): Promise<NotificationsResponse> {
    const params = agentType ? `?agentType=${agentType}` : '';
    const response = await apiClient.get<NotificationsResponse>(`/api/coach-notifications${params}`);
    return response.data;
  }

  static async getUnreadCount(): Promise<number> {
    const response = await apiClient.get<UnreadCountResponse>('/api/coach-notifications/unread-count');
    return response.data.unreadCount;
  }

  static async markAsRead(id: number): Promise<MarkReadResponse> {
    const response = await apiClient.post<MarkReadResponse>(`/api/coach-notifications/${id}/read`, {});
    return response.data;
  }

  static async markAllAsRead(): Promise<MarkAllReadResponse> {
    const response = await apiClient.post<MarkAllReadResponse>('/api/coach-notifications/read-all', {});
    return response.data;
  }

  static async getNextTrainerRun(): Promise<NextTrainerRunInfo> {
    const response = await apiClient.get<NextTrainerRunInfo>('/api/coach-notifications/next-trainer-run');
    return response.data;
  }
}
